import CreateReportContainer from "../containers/CreateReportContainer";

const CreateReportPage = () => {
  return (
    <CreateReportContainer />
  );
};

export default CreateReportPage;
